class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.bindQuantityListeners();
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  bindQuantityListeners() {
    const quantityInput = document.querySelector(`#Quantity-${this.dataset.section}`) || document.querySelector('.quantity__input');
    if (!quantityInput) return;

    this.onQuantityChange = this.onQuantityChange.bind(this);
    quantityInput.addEventListener('change', this.onQuantityChange);
    quantityInput.addEventListener('input', this.onQuantityChange);
  }

  onQuantityChange() {
    this.syncHiddenQuantity();
    if (this.currentVariant) this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    document.querySelector('#hidden-id').value = this.currentVariant.id;
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#add-to-cart-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (document.getElementsByClassName('wcp_vd_table').length != 0 && document.getElementById('vdtable') != null) {

      var source = document.getElementById('vdtable').innerHTML;
      var template = Handlebars.compile(source);
      if (document.getElementsByClassName('wcp_vd_table')[0] != undefined && document.getElementsByClassName('wcp_vd_table')[0].innerText != '') {
        var context = JSON.parse(document.getElementsByClassName('wcp_vd_table')[0].innerText);
        var vdtable = [];
        vdtable['vdtable'] = context['wpd_' + this.currentVariant.id];
        vdtable['vdtable'].forEach(function (arrayItem) {
          arrayItem.Price = arrayItem.Price.replace(/<\/?span[^>]*>/g, '');
        });
        var html = template(vdtable);

        document.getElementById('wcp_vd_table').innerHTML = html;
      }
      else {
        document.getElementById('wcp_vd_table').innerHTML = '';
      }

    }
    
  }

  syncHiddenQuantity() {
    const quantityInput = document.querySelector(`#Quantity-${this.dataset.section}`) || document.querySelector('.quantity__input');
    const productForm = document.querySelector(`form[id^="add-to-cart-"][id$="-${this.dataset.section}"]`);
    const hiddenQuantity = productForm?.querySelector('input[name="quantity"]');

    if (quantityInput && hiddenQuantity) hiddenQuantity.value = quantityInput.value;
  }

  getCurrentQuantity() {
    const quantityInput = document.querySelector(`#Quantity-${this.dataset.section}`) || document.querySelector('.quantity__input');
    const quantity = Number.parseInt(quantityInput?.value, 10);
    return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const quantity = this.getCurrentQuantity();
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&quantity=${quantity}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const buttonPriceId = `buy-now-price-${this.dataset.section}`;
        const buttonDestination = document.getElementById(buttonPriceId);
        const buttonSource = html.getElementById(buttonPriceId);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (buttonSource && buttonDestination) buttonDestination.innerHTML = buttonSource.innerHTML;

        this.applyQuantityPrice();

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  applyQuantityPrice() {
    if (!this.currentVariant?.price) return;
    const quantity = this.getCurrentQuantity();
    const saleCents = this.currentVariant.price * quantity;
    const compareCents = (this.currentVariant.compare_at_price || 0) * quantity;

    this.updatePriceText(`price-${this.dataset.section}`, saleCents, compareCents);
    this.updatePriceText(`buy-now-price-${this.dataset.section}`, saleCents, compareCents);
  }

  formatMoney(cents) {
    if (window?.Shopify?.formatMoney) {
      const moneyFormat = window?.theme?.moneyFormat || window?.Shopify?.money_format || '${{amount}}';
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  updatePriceText(containerId, saleCents, compareCents) {
    const root = document.getElementById(containerId);
    if (!root) return;

    const saleText = this.formatMoney(saleCents);
    const compareText = compareCents > saleCents ? this.formatMoney(compareCents) : null;
    const comparePriceNode = root.querySelector('.price__compare .price-item--regular');
    const salePriceNode = root.querySelector('.price-item--sale');

    if (salePriceNode) salePriceNode.textContent = saleText;
    if (comparePriceNode && compareText) comparePriceNode.textContent = compareText;

    root.querySelectorAll('.price__regular .price-item--regular').forEach((price) => {
      price.textContent = saleText;
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`add-to-cart-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`add-to-cart-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
